import { render, staticRenderFns } from "./BillSubTable.vue?vue&type=template&id=20a1a50a&scoped=true&"
import script from "./BillSubTable.vue?vue&type=script&lang=ts&"
export * from "./BillSubTable.vue?vue&type=script&lang=ts&"
import style0 from "./BillSubTable.vue?vue&type=style&index=0&id=20a1a50a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a1a50a",
  null
  
)

export default component.exports